angular.module('unica_event_tag.event_tag_controllers')

.controller('EventTagEditController', function(
	$rootScope, $scope, $state, $stateParams,
	EventTagEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventTag( $stateParams.id );

	$rootScope.eventTagData = {
		event_id: $stateParams.event_id,
	};

	$scope.saveEventTag = function()
	{
		$scope.showLoader();

		var eventTagData = angular.copy($rootScope.eventTagData);

		EventTagEditService
			.update( eventTagData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Tag aggiornato con successo!', '');

					$state.go('app.event_tag.list', { event_id: $stateParams.event_id });
				}
			});

	};

});